export default {
  USER_GET_PROVIDER: "USER_GET_PROVIDER",
  USER_LOGIN: "USER_LOGIN",
  USER_SIGNUP: "USER_SIGNUP",
  USER_SIGNUP_SUCCESS: "USER_SIGNUP_SUCCESS",
  USER_SIGNUP_FAILURE: "USER_SIGNUP_FAILURE",
  USER_SIGNUP_SET_ACTIVE: "USER_SIGNUP_SET_ACTIVE",
  USER_SIGNUP_EMAIL_CHECK: "USER_SIGNUP_EMAIL_CHECK",
  EMAIL_AUTO_LINK: "EMAIL_AUTO_LINK",
  EMAIL_AUTO_LINK_COMPLETE: "EMAIL_AUTO_LINK_COMPLETE",
  EMAIL_AUTO_LINK_SKIP: "EMAIL_AUTO_LINK_SKIP",
  EMAIL_AUTO_LINK_NEEDED: "EMAIL_AUTO_LINK_NEEDED",
  EMAIL_AUTO_LINK_HANDLE_RESULT: "EMAIL_AUTO_LINK_HANDLE_RESULT",
  EMAIL_AUTO_LINK_SUCCESS: "EMAIL_AUTO_LINK_SUCCESS",
  EMAIL_AUTO_LINK_FAILURE: "EMAIL_AUTO_LINK_FAILURE",
  REQUEST_EXIT_READINESS_CHECK: "REQUEST_EXIT_READINESS_CHECK",
  USER_LOGIN_LEGACY: "USER_LOGIN_LEGACY",
  USER_LOGIN_RESPONSE: "USER_LOGIN_RESPONSE",
  SAVE_COGNITO_USER: "SAVE_COGNITO_USER",
  USER_LOGIN_SUCCESS: "USER_LOGIN_SUCCESS",
  USER_LOGIN_FLOW_STAGE: "USER_LOGIN_FLOW_STAGE",
  USER_LOGIN_HANDLE_CHALLENGE: "USER_LOGIN_HANDLE_CHALLENGE",
  USER_LOGIN_HANDLE_PREAUTH_CHALLENGE: "USER_LOGIN_HANDLE_PREAUTH_CHALLENGE",
  USER_PROVIDER: "USER_PROVIDER",
  USER_LOGIN_ERROR: "USER_LOGIN_ERROR",
  USER_RESET_PASSWORD: "USER_RESET_PASSWORD",
  USER_RESET_PASSWORD_RESPONSE: "USER_RESET_PASSWORD_RESPONSE",
  USER_RESET_PASSWORD_CANCEL: "USER_RESET_PASSWORD_CANCEL",
  USER_CHANGE_PASSWORD: "USER_CHANGE_PASSWORD",
  USER_CHANGE_PASSWORD_RESPONSE: "USER_CHANGE_PASSWORD_RESPONSE",
  USER_CHANGE_PASSWORD_ERROR: "USER_CHANGE_PASSWORD_ERROR",
  USER_CHANGE_EMAIL: "USER_CHANGE_EMAIL",
  USER_SKIP_CHANGE_EMAIL: "USER_SKIP_CHANGE_EMAIL",
  HANDLE_ERROR: "HANDLE_ERROR",
  TRANSLATABLE_SUCCESS_MESSAGE: "SUCCESS_MESSAGE",
  TRANSLATABLE_ERROR_MESSAGE: "ERROR_MESSAGE",
  REMOVE_PROVIDER: "REMOVE_PROVIDER",
  SET_PROVIDER: "SET_PROVIDER",
  SET_S1_TRANSPORT: "SET_S1_TRANSPORT",
  TOTP_SPINNING: "TOTP_SPINNING",
  SET_FETCHING: "SET_FETCHING",
  MFA_VERIFY_TOTP_CODE: "MFA_VERIFY_TOTP_CODE",
  SET_USERNAME: "SET_USERNAME",
  SET_PASSWORD: "SET_PASSWORD",
  SET_ACCOUNT_NUMBER: "SET_ACCOUNT_NUMBER",
  SET_EMAIL: "SET_EMAIL",
  SET_PASSWORD_VALIDATION: "SET_PASSWORD_VALIDATION",
  REMEMBER_ME: "REMEMBER_ME",
  SET_DEVICE_DATA: "SET_DEVICE_DATA",
  SAVE_DEVICE: "SAVE_DEVICE",
  MFA_SETUP_COMPLETE: "MFA_SETUP_COMPLETE",
  MFA_SETUP_SKIP: "MFA_SETUP_SKIP",
  SET_MFA_TYPE_SETUP_COMPLETE: "SET_MFA_TYPE_SETUP_COMPLETE",
  MFA_REQUIRED: "MFA_REQUIRED",
  MFA_SET_SMS_NUMBER: "MFA_SET_SMS_NUMBER",
  MFA_SET_EMAIL: "MFA_SET_EMAIL",
  MFA_VERIFY_SMS_CODE: "MFA_VERIFY_SMS_CODE",
  MFA_SELECT_TYPE: "MFA_SELECT_TYPE",
  MFA_ENABLE_CHOICE: "MFA_ENABLE_CHOICE",
  MFA_VERIFY_EMAIL_CODE: "MFA_VERIFY_EMAIL_CODE",
  MFA_SKIP: "MFA_SKIP",
  MFA_RESEND_CODE: "MFA_RESEND_CODE",
  MANUAL_LINK_ACCOUNT: "MANUAL_LINK_ACCOUNT",
  MANUAL_LINK_ACCOUNT_SUCCESS: "MANUAL_LINK_ACCOUNT_SUCCESS",
  MANUAL_LINK_ACCOUNT_FAILURE: "MANUAL_LINK_ACCOUNT_FAILURE",
}
